import Dashboard from './components/Dashboard.vue';
import Profile from '../common_components/Profile.vue';
import Chat from './components/Chat.vue';
import PersonalChat from './components/PersonalChat.vue';
import Login from '../common_components/Login.vue';
import NoLocalStorage from './components/NoLocalStorage.vue';
import PasswordReset from '../common_components/PasswordReset.vue';
import TeacherCabinet from './components/Teacher/TeacherCabinet.vue'
import TeacherLesson from './components/Teacher/TeacherLesson.vue'

import VueRouter from 'vue-router';

export const routes = [
    { path: '/', name: 'dashboard', component: Dashboard },
    { path: '/login', name: 'login', component: Login },
    { path: '/profile', name: 'profile', component: Profile },
    { path: '/channel/:id', name: 'channel', component: Chat },
    { path: '/personal-channel/:id', name: 'personal-channel', component: PersonalChat },
    { path: '/password-reset', name: 'password_reset', component: PasswordReset },
    { path: '/teacher-cabinet', name: 'teacher_cabinet', component: TeacherCabinet },
    { path: '/teacher-lesson', name: 'teacher_lesson', component: TeacherLesson },
    { path: '/no-localstorage', name: 'no-localstorage', component: NoLocalStorage },
];

export default new VueRouter({
    mode: 'history',
    routes,
    base: '/'
})
